import React from "react";
import {CButton} from "@coreui/react";
import {withErrorBoundary} from "../../../components/ErrorBoundary";

const CheckActionButton = (props) => {
  const {color, variant, text, className, checkId, onCheckActionButtonClick, isEnabled} = props;

  const isReturnBtn = text === "Return";

  return (
    <CButton
      className={className}
      color={color}
      variant={variant}
      onClick={
        isReturnBtn ? () => onCheckActionButtonClick(checkId)
          : () => onCheckActionButtonClick(checkId, isEnabled)}
    >
      {text}
    </CButton>
  );
};

export default withErrorBoundary(CheckActionButton);